export function isAreasDataValid(areas) {
  if (!areas || !areas.length) {
    return false;
  }
  for (let i = 0; i < areas.length; i++) {
    const area = areas[i];
    if (!area.finalPlans || !area.finalPlans.plans || !area.finalPlans.plans.length) {
      return false;
    }
  }

  return true;
}
